import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-update-lead-space',
  imports: [SharedModule],
  templateUrl: './update-lead-space.component.html',
  styleUrl: './update-lead-space.component.scss'
})
export class UpdateLeadSpaceComponent {
  @Output() closeDialog = new EventEmitter<void>();
  @Output() reloadTabs = new EventEmitter<string>();
  @Input() activeTab: string = '';
  @Input() activeTabName: string = '';
  groupName: string = this.activeTabName;
  isLoading: boolean = false;



  constructor(
    private api: LeadService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    console.log(this.activeTabName);
    console.log(this.activeTab);
    this.groupName = this.activeTabName;
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleUpdateGroup() {
    const payload = {
      id: this.activeTab,
      name: this.groupName
    };
    this.isLoading = true;
    this.api.updateLeadSpace(payload).subscribe({
      next: (response) => {

        this.reloadTabs.emit(this.groupName);
          this.closeDialog.emit();
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Group updated successfully'
          });
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message || 'Something went wrong'
        });
      }
    });
  }

}
